import roleFacet from '~/modules/common/components/SearchBox/Facets/RoleFacet';
import ResourcePoolFacet from '~/modules/common/components/SearchBox/Facets/ResourcePoolFacet';
import { ProjectResourceFacet } from '~/modules/common/components/SearchBox/Facets/UserFacet';

const getFacets = () => [ProjectResourceFacet, roleFacet, ResourcePoolFacet];

export default getFacets;
